export default __webpack_public_path__ + "static/media/img (4).e9197a3a.jpg";